/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Images
import ddos_illustration from '../../assets/images/illustrations/ddos.svg';
import ddos_level from '../../assets/images/illustrations/ddos_level.svg';

function ddosProtection() {
    return (
        <section className="ddos-protection py-28">
            <div className="py-28 bg-primaryDark">
                <div className="max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
                    <div className="grid grid-cols-2 gap-8">
                        <div className="col-span-2 sm:col-span-2 md:col-span-2 lg:col-span-1">
                            <h1 className="text-gray-100 font-semibold text-3xl mb-8 text-center sm:text-center md:text-center lg:text-left">Free DDoS Protection</h1>
                            <p className="text-gray-300 mb-12 text-center sm:text-center md:text-center lg:text-left">From basic UDP floods to Source Engine query attacks, we've got you covered. Most of todays attacks target application exploits rather than leveraging pure bandwidth. Our platform is carefully tuned and actively adjusted as necessary to keep todays attacks at bay and your services online.</p>
                            <img src={ddos_level} alt="DDoS Level" className="w-48 block mx-auto sm:mx-auto md:mx-auto lg:mx-0" />
                        </div>
                        <div className="hidden sm:hidden md:hidden lg:block">
                            <img src={ddos_illustration} alt="DDoS Illustration" className="block ml-auto" Style="margin-top: -170px;" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ddosProtection